/* eslint-disable react/prop-types */
import React from 'react'
import styled from 'styled-components'

import TableForm from 'live/components/forms/ui/TableForm'

const StyledTableForm = styled(TableForm)`
    tbody > tr:first-child {
        td > .far.fa-trash-alt {
            display: none;
        }
    }
`

const ConditionsEditor = ({
    conditions,
    setConditions,
    ChannelSelector,
    ComparatorSelector,
    ThresholdInput,
    disabled
}) => (
    <StyledTableForm
        fields={[
            {
                name: 'channel',
                label: 'Channel',
                type: 'text',
                render: ChannelSelector
            },
            { name: 'comparator', label: 'Operation', type: 'text', render: ComparatorSelector },
            { name: 'threshold', label: 'Threshold', type: 'number', render: ThresholdInput }
        ]}
        data={conditions}
        allowRemoveRow={!disabled && conditions.length > 1}
        allowAddRow={!disabled}
        onChange={setConditions}
    />
)

export default ConditionsEditor
